module.exports = new __parcel__URL__("kb-hub-third-party-connector.13204c29.svg").toString();